<template>
  <div class="home">
    
    <mesInfosParents></mesInfosParents>
      
  </div>
</template>

<script>
import mesInfosParents from '@/components/mesInfosParents.vue'

export default {
  name: 'infosParents',
  components: {
    mesInfosParents
  }
}
</script>
